import { Prop, Watch } from "vue-property-decorator";
import { ContractsStore } from "../../store/modules/contracts";
import { ConfigStore } from "../../store/modules/config";
import { HistoryStatus } from "../../data/enums/HistoryStatus";
import { getModule } from "vuex-module-decorators";
import i18n from "@/i18n";
import Vue from "vue";

export class OperationsFilterVue extends Vue {
  @Prop() filteredArray!: Array<any>;

  @Prop() isChart!: boolean;

  @Prop() statusFilter!: boolean;

  @Prop() contractFilter!: boolean;

  @Prop() hideOperationsFilter!: boolean;

  /**Стор настроек */
  get configStore(): ConfigStore {
    return getModule(ConfigStore, this.$store);
  }

  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  /** Флаг заргузки списка счетов */
  get loading(): boolean {
    return this.contractsStore.loading;
  }

  /** Флаг отображения списка скрытых счетов и карт */
  get isHiddenItemsVissible(): boolean {
    return this.configStore.isHiddenItemsVissible;
  }

  /** Получение списка контрактов */
  get contracts(): any {
    const contracts = this.contractsStore.contracts.AllContracts;
    const result: Array<any> = [
      { title: i18n.t("main.historyFilters.all"), value: null }
    ];
    for (const key in contracts) {
      const contract = contracts[key];
      if (
        (contract.IsOpen && !contract.Data.Hidden) ||
        this.isHiddenItemsVissible
      ) {
        result.push({
          title: contract.Data.Alias,
          value: contract.Data.Id
        });
      }
    }
    return result;
  }

  /** Значение фильтра */
  operationsFilter: any = {
    category: "all",
    contract: null,
    status: 31 as HistoryStatus
  };

  statusBar: Array<any> = [
    {
      title: i18n.t("main.historyFilters.all"),
      value: 31 as HistoryStatus
    },
    {
      title: i18n.t("main.historyFilters.success"),
      value: 25 as HistoryStatus
    },
    {
      title: i18n.t("main.historyFilters.failed"),
      value: 26 as HistoryStatus
    },
    {
      title: i18n.t("main.historyFilters.waiting"),
      value: 28 as HistoryStatus
    }
  ];

  /** Свернут график или нет */
  chartHidden: boolean = false;

  /** Изменение фильтра */
  @Watch("operationsFilter.category", { immediate: true })
  categoryChaged() {
    this.$emit("filterChange", { category: this.operationsFilter.category });
    this.$emit('changeActiveCategory', null);
  }

  statusChange() {
    this.$emit("filterChange", { status: this.operationsFilter.status });
  }

  contractChange() {
    this.$emit("filterChange", { contract: this.operationsFilter.contract });
  }

  /** Изменение свернутого графика */
  @Watch("chartHidden", { immediate: true })
  chartHiddenChanged() {
    this.$emit("chartToggle", { isShow: this.chartHidden });
  }

  /** Показывать ли тоглер графика */
  get isHidderShow() {
    return (
      this.filteredArray.length > 0 &&
      this.operationsFilter.category !== "all" &&
      this.isChart
    );
  }
}
